var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c(
        "div",
        {
          class: { passthrough: _vm.passthrough },
          attrs: { id: "context-menu-container" },
          on: {
            click: _vm.containerClick,
            contextmenu: function ($event) {
              $event.preventDefault()
              return _vm.containerClick.apply(null, arguments)
            },
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp",
                  ])
                ) {
                  return null
                }
                if (
                  $event.ctrlKey ||
                  $event.shiftKey ||
                  $event.altKey ||
                  $event.metaKey
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.navigateMenu(-1)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown",
                  ])
                ) {
                  return null
                }
                if (
                  $event.ctrlKey ||
                  $event.shiftKey ||
                  $event.altKey ||
                  $event.metaKey
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.navigateMenu(1)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                ) {
                  return null
                }
                if (
                  $event.ctrlKey ||
                  $event.shiftKey ||
                  $event.altKey ||
                  $event.metaKey
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.navigateMenu(1)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                ) {
                  return null
                }
                if (!$event.shiftKey) {
                  return null
                }
                $event.preventDefault()
                return _vm.navigateMenu(-1)
              },
            ],
          },
        },
        [
          _c(
            "ul",
            {
              ref: "contextMenu",
              style: _vm.style,
              attrs: { id: "context-menu", role: "menu", tabindex: "-1" },
              on: {
                mouseleave: function ($event) {
                  _vm.activeItem = -1
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                  return _vm.clickActiveItem.apply(null, arguments)
                },
              },
            },
            [
              _vm._l(_vm.items, function (item, id) {
                return [
                  _c(
                    "li",
                    {
                      key: item.name,
                      class: [
                        "context-menu-" + item.type,
                        item.class ? "context-menu-" + item.class : null,
                        { active: id === _vm.activeItem },
                      ],
                      attrs: { role: "menuitem" },
                      on: {
                        mouseenter: function ($event) {
                          return _vm.hoverItem(id)
                        },
                        click: function ($event) {
                          return _vm.clickItem(item)
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t" + _vm._s(item.label) + "\n\t\t\t")]
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }